import Head from "next/head";
import { make as SetWrappedPage } from "../../../src/set-wrapped9/SetWrapped9Page.bs";
import { fromName, toApiName } from "common/src/Region.bs.js";

export default function Player({ region, playerName, queueId } = {}) {
  return (
    <>
      <Head>
        <meta name="viewport" content="width=640px, maximum-scale=1" />
        <title>Set 9 Runeterra Reforged Wrapped - Teamfight Tactics</title>
      </Head>
      <SetWrappedPage
        region={region || undefined}
        playerName={playerName || undefined}
        queueId={queueId || undefined}
      />
    </>
  );
}

export async function getStaticPaths() {
  return {
    paths: [],
    fallback: "blocking",
  };
}

export async function getStaticProps({ params, locale }) {
  const slug = params.slug || [];
  let region = null;
  let playerName = null;
  let queueId = null;
  if (slug.length === 3) {
    region = slug[0];
    playerName = slug[1];
    queueId = Number(slug[2]);
  }

  return {
    props: {
      region,
      playerName,
      queueId,
    },
  };
}
